import axios from 'axios'
import store from '@/store'
export default () => {
  return axios.create({
    baseURL: `https://heel.lease.complement-it.com/api/`,
    //baseURL: `http://localhost:7280/api/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}
